// @file Vuex Store for showing Alert Dialog (e.g. when user is over the file size quota)
import type { DispatchableAction } from '@@/types'
import type { Module } from 'vuex'

interface AlertDialogPayload {
  iconSrc?: string | null
  iconAlt?: string | null
  title?: string
  body?: string
  closeButtonText?: string
  xShadow?: boolean
  shouldFadeIn?: boolean
  afterCloseActions?: Array<DispatchableAction | (() => void)>
}

interface AlertDialogState extends Required<AlertDialogPayload> {
  isOpen: boolean
}

const blankState = (): AlertDialogState => ({
  isOpen: false,

  iconSrc: null,
  iconAlt: null,
  title: '',
  body: '',
  closeButtonText: '',
  xShadow: false,
  shouldFadeIn: false,
  afterCloseActions: [],
})

const AlertDialogModule: Module<AlertDialogState, object> = {
  namespaced: true,
  state: blankState,
  mutations: {
    RESET_ALERT_DIALOG(state): void {
      Object.assign(state, blankState())
    },
    OPEN_ALERT_DIALOG(state, dialogState: Partial<AlertDialogState>): void {
      Object.assign(state, dialogState)
      state.isOpen = true
    },
  },
  actions: {
    openAlertDialog({ commit }, params: AlertDialogPayload): void {
      commit('OPEN_ALERT_DIALOG', params)
    },
    executeCloseActions({ dispatch }, actions?: Array<DispatchableAction | (() => void)>): void {
      if (actions === undefined) return

      actions.forEach((action): void => {
        if (typeof action === 'function') {
          action()
        } else {
          void dispatch(action.type, action.payload, { root: true })
        }
      })
    },
    close({ commit, dispatch, state }): void {
      void dispatch('executeCloseActions', state.afterCloseActions)
      commit('RESET_ALERT_DIALOG')
    },
  },
}

export default AlertDialogModule
export type { AlertDialogPayload, AlertDialogState }
